import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Skeleton } from "@/components/ui/skeleton";
import { orpcPublic } from "@/lib/orpc";
import { JobCard } from "../-components/job-card";
import { JobsNotFound } from "@/routes/jobs-preview/$domain/-components/jobs-not-found";
import { JobsShell } from "../-components/jobs-shell";

export const Route = createFileRoute("/jobs-preview/$domain/$boardSlug/")({
  component: JobsBoard,
});

/** One board's open positions at this building. */
function JobsBoard() {
  const { domain, boardSlug } = Route.useParams();
  const page = useQuery({
    ...orpcPublic.careers.jobsByDomainBoard.queryOptions({ input: { domain, boardSlug } }),
    retry: false,
  });

  if (page.isError) {
    return (
      <JobsShell domain={domain}>
        <JobsNotFound />
      </JobsShell>
    );
  }

  return (
    <JobsShell domain={domain} facilityName={page.data?.facility.name}>
      {page.isPending ? (
        <div className="space-y-3">
          <Skeleton className="h-8 w-56" />
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-20 w-full" />
        </div>
      ) : (
        <>
          <div className="mb-6">
            <h1 className="font-display text-2xl text-balance">{page.data?.board.name}</h1>
            {page.data?.board.description ? (
              <p className="text-muted-foreground mt-1">{page.data.board.description}</p>
            ) : null}
          </div>
          <div className="space-y-3">
            {(page.data?.jobs ?? []).map((job) => (
              <JobCard boardSlug={boardSlug} domain={domain} job={job} key={job.id} />
            ))}
          </div>
        </>
      )}
    </JobsShell>
  );
}
